import { ErrorLayout } from '@uag/react-core';

export const Unauthorized = () => {
    return <ErrorLayout description="Sorry, you don't have the required role to access this page." title="403" />;
};
